<template>
  <sidebar-item :link="{name: $t('Токены'),  path: `/tokens`,  icon: 'vip_icon icon_suppliers'}">
  </sidebar-item>
</template>
<script>
    export default {}
</script>
